import { IFormFilter } from "src/reducers";
import * as Dtos from "../dtos/Tmd.dtos";

export const
    LoadInstitutionItemById: IInstitutionItemLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_INSTITUTIONITEM_LOAD_BY_ID,
            id
        }
    },
    LoadInstitutionItemsByInstitutionId: IInstitutionItemsLoadByInstitutionIdActionCreator = (institutionId) => {
        return {
            type: ACTION_INSTITUTIONITEMS_LOAD_BY_INSTITUTION_ID,
            institutionId
        }
    },
    LoadSuccess: IInstitutionItemLoadSuccessActionCreator = (formData, formDataInstitutioned, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONITEM_LOAD_SUCCESS,
            formData,
            formDataInstitutioned,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IInstitutionItemLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONITEM_LOAD_FAILURE,
            responseStatus
        }
    },
    SaveInstitutionItem: IInstitutionItemSaveActionCreator = (formData, collectionFormData) => {
        return {
            type: ACTION_INSTITUTIONITEM_SAVE,
            formData,
            collectionFormData
        }
    },
    SaveSuccess: IInstitutionItemSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONITEM_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IInstitutionItemSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONITEM_SAVE_FAILURE,
            responseStatus
        }
    },
    CreateInstitutionItem: IInstitutionItemCreateActionCreator = (institutionId) => {

        return {
            type: ACTION_INSTITUTIONITEM_CREATE,
            institutionId
        }
    },
    CreateSuccess: IInstitutionItemCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_INSTITUTIONITEM_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IInstitutionItemCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONITEM_CREATE_FAILURE,
            responseStatus
        }
    },
    Clear: IInstitutionItemClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_INSTITUTIONITEM_CLEAR,
            propertiesToClear
        }
    },
    Filter: IInstitutionItemFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_INSTITUTIONITEM_FILTER,
            formFilter
        }
    };

export const
    ACTION_INSTITUTIONITEMS_LOAD_BY_ID = "ACTION_INSTITUTIONITEMS_LOAD_BY_ID",    
    ACTION_INSTITUTIONITEMS_LOAD_BY_INSTITUTION_ID = "ACTION_INSTITUTIONITEMS_LOAD_BY_INSTITUTION_ID",
    ACTION_INSTITUTIONITEM_LOAD_BY_ID = "ACTION_INSTITUTIONITEM_LOAD_BY_ID",
    ACTION_INSTITUTIONITEM_LOAD_SUCCESS = "ACTION_INSTITUTIONITEM_LOAD_SUCCESS",
    ACTION_INSTITUTIONITEM_LOAD_FAILURE = "ACTION_INSTITUTIONITEM_LOAD_FAILURE",

    ACTION_INSTITUTIONITEM_SAVE = "ACTION_INSTITUTIONITEM_SAVE",
    ACTION_INSTITUTIONITEM_SAVE_SUCCESS = "ACTION_INSTITUTIONITEM_SAVE_SUCCESS",
    ACTION_INSTITUTIONITEM_SAVE_FAILURE = "ACTION_INSTITUTIONITEM_SAVE_FAILURE",

    ACTION_INSTITUTIONITEM_CREATE = "ACTION_INSTITUTIONITEM_CREATE",
    ACTION_INSTITUTIONITEM_CREATE_SUCCESS = "ACTION_INSTITUTIONITEM_CREATE_SUCCESS",
    ACTION_INSTITUTIONITEM_CREATE_FAILURE = "ACTION_INSTITUTIONITEM_CREATE_FAILURE",

    ACTION_INSTITUTIONITEM_CLEAR = "ACTION_INSTITUTIONITEM_CLEAR",
    ACTION_INSTITUTIONITEM_FILTER = "ACTION_INSTITUTIONITEM_FILTER";

export interface IInstitutionItemLoadByIdAction {
    type: "ACTION_INSTITUTIONITEM_LOAD_BY_ID";
    id: number;
}

export interface IInstitutionItemLoadByIdActionCreator {
    (id: number): IInstitutionItemLoadByIdAction;
}

export interface IInstitutionItemsLoadByInstitutionIdAction {
    type: "ACTION_INSTITUTIONITEMS_LOAD_BY_INSTITUTION_ID";
    institutionId: number;
}

export interface IInstitutionItemsLoadByInstitutionIdActionCreator {
    (institutionId: number): IInstitutionItemsLoadByInstitutionIdAction;
}

export interface IInstitutionItemLoadSuccessAction {
    type: "ACTION_INSTITUTIONITEM_LOAD_SUCCESS";
    formData: Dtos.InstitutionItem | Dtos.InstitutionItem[];
    formDataInstitutioned: Dtos.InstitutionItemCategory[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionItemLoadSuccessActionCreator {
    (
        formData: Dtos.InstitutionItem | Dtos.InstitutionItem[],
        formDataInstitutioned: Dtos.InstitutionItemCategory[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionItemLoadSuccessAction;
}

export interface IInstitutionItemLoadFailureAction {
    type: "ACTION_INSTITUTIONITEM_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionItemLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionItemLoadFailureAction;
}

export interface IInstitutionItemSaveAction {
    type: "ACTION_INSTITUTIONITEM_SAVE";
    formData: Dtos.InstitutionItem;
    collectionFormData: Dtos.Collection;

}

export interface IInstitutionItemSaveActionCreator {
    (
        formData: Dtos.InstitutionItem,
        collectionFormData: Dtos.Collection
    ): IInstitutionItemSaveAction;
}

export interface IInstitutionItemSaveSuccessAction {
    type: "ACTION_INSTITUTIONITEM_SAVE_SUCCESS";
    formData: Dtos.InstitutionItem;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionItemSaveSuccessActionCreator {
    (
        formData: Dtos.InstitutionItem,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionItemSaveSuccessAction;
}

export interface IInstitutionItemSaveFailureAction {
    type: "ACTION_INSTITUTIONITEM_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionItemSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionItemSaveFailureAction;
}

export interface IInstitutionItemCreateAction {
    type: "ACTION_INSTITUTIONITEM_CREATE",
    institutionId: number
}

export interface IInstitutionItemCreateActionCreator {
    (institutionId: number): IInstitutionItemCreateAction
}

export interface IInstitutionItemCreateSuccessAction {
    type: "ACTION_INSTITUTIONITEM_CREATE_SUCCESS";
    formData: Dtos.InstitutionItem;
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
}

export interface IInstitutionItemCreateSuccessActionCreator {
    (
        formData: Dtos.InstitutionItem,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IInstitutionItemCreateSuccessAction;
}

export interface IInstitutionItemCreateFailureAction {
    type: "ACTION_INSTITUTIONITEM_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionItemCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionItemCreateFailureAction;
}

export interface IInstitutionItemClearAction {
    type: "ACTION_INSTITUTIONITEM_CLEAR";
    propertiesToClear?: string[];
}

export interface IInstitutionItemClearActionCreator {
    (propertiesToClear?: string[]): IInstitutionItemClearAction;
}

export interface IInstitutionItemFilterActionCreator {
    (formFilter: IFormFilter): IInstitutionItemFilterAction;
}

export interface IInstitutionItemFilterAction {
    type: "ACTION_INSTITUTIONITEM_FILTER";
    formFilter: IFormFilter;
}

export type InstitutionItemAction =
    IInstitutionItemLoadByIdAction |
    IInstitutionItemsLoadByInstitutionIdAction |
    IInstitutionItemLoadFailureAction |
    IInstitutionItemLoadSuccessAction |
    IInstitutionItemSaveAction |
    IInstitutionItemSaveSuccessAction |
    IInstitutionItemSaveFailureAction |
    IInstitutionItemCreateAction |
    IInstitutionItemCreateSuccessAction |
    IInstitutionItemCreateFailureAction |
    IInstitutionItemClearAction |
    IInstitutionItemFilterAction;
